import React from "react";
import { Grid } from "@material-ui/core";
import { StatsOverview, ClientListTable } from "../Dashboard/components";

export function Dashboard() {
  return (
    <Grid container direction="column" spacing={5}>
      <Grid item>
        <StatsOverview />
      </Grid>
      <Grid item>
        <ClientListTable />
      </Grid>
    </Grid>
  );
}
